import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    busy: false,
    hasLogin: false,//是否登录
    goBackRefresh: false,//是否需要刷新
    userInfo: {},//登录账户信息
    houseMaintenance: {//房源管理相关信息
      apartmentType: '',
      createId: '',
      cache: {}
    },
    signCenterTab: '',//签约中心标签页
    // 投诉模块
    employmentOrganization: {},//从业机构
    employeesList: [], //从业人员
    // 备案中心
    houseSourceId: '', //房源id
    houseSourceData: {}, //房源信息
    mapService: {
      tdToken: "", //天地图
      MXAddress: "", //三维地图服务地址 //-
      APIAddress: "",
      ldUrl: "",  //楼栋服务地址
      xqUrl: "",  //小区服务地址
      sqUrl: "",  //区县服务地址
      jdUrl: "",  //街道服务地址
    },
    houseEmplOrLnstType: '',
    houseEmplOrLnst: []
  },
  mutations: {
    login (state, changeToken) {
      state.hasLogin = changeToken.hasLogin;
      if (window) {
        localStorage.setItem("access_token", changeToken.token);
      }
    },
    backRefresh (state, params) {
      state.goBackRefresh = params;
    },
    HSSaveCreateID (state, id) {
      state.houseMaintenance.createId = id;
    },
    HSSaveCType (state, type) {
      state.houseMaintenance.apartmentType = type;
    },
    HSSaveCache (state, obj) {
      state.houseMaintenance.cache = obj;
    },
    saveSignCenterTab (state, type) {
      state.signCenterTab = type;
    },
    // ----------------------------------------------------
    updateEmploymentOrganization (state, obj) {
      state.employmentOrganization = obj
    },
    updateEmployeesList (state, ary) {
      state.employeesList = ary
    },
    updateHouseSourceId (state, id) {
      state.houseSourceId = id
    },
    saveUserInfo (state, data) {
      state.userInfo = data
      console.log('saveUserInfo', data)
    },
    saveMapService (state, data) {
      state.mapService = data
      console.log('saveMapService', data)
    },
    updateHouseEmplOrLnst (state, ary) {
      state.houseEmplOrLnst = ary
    },
    updateHouseEmplOrLnstType (state, type) {
      state.houseEmplOrLnstType = type
    }

  },
  actions: {
    login (context, changeToken) {
      context.commit('login', changeToken)
    },
    saveUserInfo (context, data) {
      context.commit('saveUserInfo', data)
    },
    HSSaveCreateID (c, id) {
      c.commit('HSSaveCreateID', id)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js